<template>
  <div class="ai-assistant-prompts">
    <div
      v-for="(item, index) in promptsList"
      v-show="item.prompts && item.prompts.length > 0"
      :key="index"
      class="ai-assistant-prompts"
    >
      <div class="ai-assistant-prompts__title">{{ item.group_name }}</div>
      <a-space style="flex-wrap: wrap;">
        <div
          v-for="(pItem, pIndex) in item.prompts"
          :key="`${index}-${pIndex}`"
          class="ai-assistant-prompts-card"
          @click="onClick(pItem)"
        >
          <TextTooltip :text="pItem.title" class="ai-assistant-prompts__title"></TextTooltip>
          <div class="ai-assistant-prompts__desc">{{ pItem.content }}</div>
        </div>
      </a-space>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextTooltip from '@/components/TextTooltip.vue'
export default {
  components: {
    TextTooltip
  },
  data () {
    return {
      promptsList: [],
      activeKey: undefined
    }
  },
  computed: {
    ...mapGetters('aiAssistant', ['prompts']),
    ...mapGetters(['activePane'])
  },
  watch: {
    'activePane.useTopic': {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.promptsList = [{
            group_name: '团队模板',
            prompts: (this.activePane.topicList || []).map(item => ({ title: item.topicName, content: item.topicContent }))
          }, ...this.prompts]
        } else {
          this.promptsList = this.prompts
        }
      }
    }
  },
  methods: {
    onClick (prompt) {
      this.$emit('click', prompt)
    }
  }
}
</script>

<style lang="less" scoped>
.ai-assistant-prompts__title {
  position: relative;
  color: #0B1019;
  font-size: 12px;
  font-weight: 700;
  line-height: 28px;
}
.ai-assistant-prompts__desc {
  margin-bottom: 4px;
  color: #434B5B;
  font-size: 10px;
  font-weight: 300;
  // 最多显示两行
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ai-assistant-prompts-card {
  margin-bottom: 8px;
  padding: 5px 8px;
  width: 145px;
  height: 74px;
  border: 1px solid #E5E8EB;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    border-color: #1E5AF9;

    .ai-assistant-prompts__title,
    .ai-assistant-prompts__desc {
      color: #1E5AF9;
    }
  }
}
</style>
